import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Line, VictoryAxis, VictoryLabel } from 'victory';

const Y = ({
  tickValues,
  tickFormats,
  angle,
  dx,
  isEmpty,
  label,
  format,
  padding
}) => {
  const gridClasses = classnames('particles-axis__grid', 'particles-axis__grid--y', {
    'particles-axis__grid--empty': !!isEmpty
  });
  const tickLabelClasses = classnames('particles-axis__tick-label', 'particles-axis__tick-label--y', {
    'particles-axis__tick-label--empty': !!isEmpty
  });
  const axisLabelClasses = classnames('particles-axis__axis-label', 'particles-axis__axis-label--y', {
    'particles-axis__axis-label--empty': !!isEmpty
  });
  const axisClasses = classnames('particles-axis__axis', 'particles-axis__axis--y', {
    'particles-axis__axis--empty': !!isEmpty
  });
  const tickClasses = classnames('particles-axis__tick', 'particles-axis__tick--y', {
    'particles-axis__tick--empty': !!isEmpty
  });
  return (
    <VictoryAxis
      dependentAxis
      fixLabelOverlap
      label={label}
      key="y-axis"
      style={{ ticks: { size: 5 }, axisLabel: { padding } }}
      tickComponent={<Line type="tick" className={tickClasses} />}
      axisComponent={<Line type="axis" className={axisClasses} />}
      gridComponent={<Line type="grid" className={gridClasses} />}
      tickLabelComponent={<VictoryLabel className={tickLabelClasses} angle={angle} dx={dx} />}
      axisLabelComponent={<VictoryLabel className={axisLabelClasses} />}
      tickValues={isEmpty ? tickValues : undefined}
      tickFormat={tickFormats}
    />
  );
};

Y.propTypes = {
  padding: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  tickValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  tickFormats: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    PropTypes.func
  ]),
  angle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEmpty: PropTypes.oneOfType([PropTypes.bool]),
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Y.defaultProps = {
  padding: 30,
  tickValues: [0],
  tickFormats: [0],
  angle: 0,
  dx: 0,
  label: '',
  isEmpty: false
};

Y.displayName = 'Chart.Axis.Y';

export default Y;

export const {
  propTypes,
  defaultProps,
  displayName
} = Y;
